import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";

/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
import { forOwn } from '../../utils/lang';
import logFactory from '../../utils/logger';
var log = logFactory('splitio-producer:offline');
function FromObjectUpdaterFactory(Fetcher, context) {
  var _context$getAll = context.getAll(),
    settings = _context$getAll[context.constants.SETTINGS],
    readiness = _context$getAll[context.constants.READINESS],
    storage = _context$getAll[context.constants.STORAGE];
  return function ObjectUpdater() {
    var splits = [];
    var loadError = null;
    var splitsMock = {};
    try {
      splitsMock = Fetcher(settings);
    } catch (err) {
      loadError = err;
      log.error("There was an issue loading the mock Splits data, no changes will be applied to the current cache. ".concat(err));
    }
    if (!loadError && splitsMock) {
      log.debug('Splits data: ');
      log.debug(_JSON$stringify(splitsMock));
      forOwn(splitsMock, function (val, name) {
        splits.push([name, _JSON$stringify({
          name: name,
          status: 'ACTIVE',
          killed: false,
          trafficAllocation: 100,
          defaultTreatment: 'control',
          conditions: val.conditions || [],
          configurations: val.configurations,
          trafficTypeName: val.trafficTypeName
        })]);
      });
      return _Promise.all([storage.splits.flush(), storage.splits.addSplits(splits)]).then(function () {
        readiness.splits.emit(readiness.splits.SDK_SPLITS_ARRIVED);
        readiness.segments.emit(readiness.segments.SDK_SEGMENTS_ARRIVED);
      });
    } else {
      return _Promise.resolve();
    }
  };
}
export default FromObjectUpdaterFactory;